import { createStyles } from '@mantine/core'
import React from 'react'

type TValueCurrency = number

type TCurrency = {
  value: TValueCurrency
  currency?: string
  showAsteriks?: boolean
  showColors?: boolean
  showSign?: boolean
}

type Tspan = {
  showColors: boolean
  value: TValueCurrency
}

interface NumberFormatOptions {
  localeMatcher?: string
  style?: string
  currency?: string
  currencyDisplay?: string
  currencySign?: string
  useGrouping?: boolean
  minimumIntegerDigits?: number
  minimumFractionDigits?: number
  maximumFractionDigits?: number
  minimumSignificantDigits?: number
  maximumSignificantDigits?: number
}

interface IFormatCurrency extends Intl.NumberFormatOptions {
  locale?: string
  showSign?: boolean
  value: TValueCurrency
}

const useStyle = createStyles(
  (theme, { showColors, value }: { showColors: boolean; value: number }) => ({
    wrapper: {
      color: showColors ? (value === 0 ? '' : value > 0 ? 'green' : 'red') : '',
    },
  }),
)

export const formatCurrency = ({
  locale = 'de-DE',
  showSign,
  value,
  currency,
  ...rest
}: IFormatCurrency): string => {
  // TODO: use actual locale

  const opts: Intl.NumberFormatOptions = {
    style: 'currency',
    currency,
    ...rest,
  }

  try {
    return `${
      showSign && Math.sign(value) >= 0 ? '+' : ''
    }${new Intl.NumberFormat(locale, opts).format(value)}`
  } catch (err) {
    return `${showSign && Math.sign(value) >= 0 ? '+' : ''}${value?.toFixed(2)}`
  }
}

const Currency = ({
  value,
  currency = 'CHF',
  showAsteriks = false,
  showColors = false,
  showSign,
}: TCurrency): React.ReactElement => {
  const valueNumber =
    typeof value === 'string' ? parseFloat(value as unknown as string) : value
  const { classes } = useStyle({ showColors, value: valueNumber })
  return (
    <span className={classes.wrapper}>
      {formatCurrency({
        value: valueNumber,
        currency,
        showSign,
        minimumFractionDigits: 2,
      })}
      {showAsteriks && ' *'}
    </span>
  )
}

export default Currency
